const movies = [
    {
      name: '365 Days this day',
      description: 'Laura and Massimo attempt to piece their lives back together following the inter-mafia conflict. However, Massimo\'s family ties and a mysterious man bidding for Laura\'s heart complicate the lovers\' lives.',
      releaseDate: '2022',
      director: 'Barbara Białowąs',
      language: 'English',
      price: 10,
      occupied: [20, 21, 30, 1, 2, 8],
      image: '365-days.jpeg',
      imageLandscape: '365-days-large.webp',
      type: 'Action, Drama',
      rating: 4,
    },
    {
      name: 'The Takedown',
      description: 'Ousmane and François are two cops with very different styles. The unlikely pair are reunited once again for a new investigation. What seemed to be a simple drug deal turns out to be a high-scale criminal case wrapped in danger.',
      director: 'Louis Leterrier',
      language: 'French',
      releaseDate: '6 May 2022',
      price: 12,
      occupied: [9, 41, 35, 11, 65, 26],
      image: 'takedown.jpeg',
      type: 'Comedy, Family',
      rating: 5,
    },
    {
      name: 'A Perfect Pairing',
      description: 'To win over a major client, a go-getter LA wine executive signs on to work at an Australian sheep farm, where she sparks with a rugged and mysterious local.',
      director: 'Stuart McDonald',
      releaseDate: '19 May 2022',
      language: 'English',
      price: 8,
      occupied: [37, 25, 44, 13, 2, 3],
      image: 'A-perfect-pairing.jpeg',
      type: 'Family, Drama',
      rating: 6.1,
    },
    {
      name: 'De-Laurte',
      description: 'A married couple on the brink of disillusion allows a stranger to live with them in their idyllic cottage. Will this stranger push their fragile state over.',
      director: 'Tom Hughes',
      releaseDate: '23 May 2021',
      language: 'English',
      price: 9,
      occupied: [10, 12, 50, 33, 28, 47],
      image: 'de-lautre.webp',
      type: 'Comedy, Drama',
      rating: 5,
    },
    {
      name: 'Captain India',
      description: 'Captain India is an unreleased computer-animated film. In this film Yuvraj Singh has given his voice, and the fantasy story is loosely based on the life of this cricketer.',
      director: 'Manny Bains',
      releaseDate: '2010',
      language: 'English',
      price: 9,
      occupied: [10, 12, 50, 33, 28, 47],
      image: 'captain-india.jpeg',
      type: 'Action, Drama',
      rating: 8,
    },
    {
      name: 'Metal Lords',
      description: 'For teenage misfits Hunter and Kevin, the path to glory is clear: devote themselves to metal, win Battle of the Bands, and be worshipped like gods.',
      director: 'Peter Sollett',
      releaseDate: '8 April 2022',
      language: 'English',
      price: 12,
      occupied: [9, 41, 35, 11, 65, 26],
      image: 'metal-lords.jpeg',
      type: 'Drama, Thriller',
      rating: 6.7,
    },
    {
      name: 'RRR',
      description: 'A tale of two legendary revolutionaries and their journey far away from home. After their journey they return home to start fighting back against British colonialists in the 1920s.',
      director: 'Stuart McDonald',
      releaseDate: '19 May 2022',
      language: 'English',
      price: 8,
      occupied: [37, 25, 44, 13, 2, 3],
      image: 'rrr.webp',
      type: 'Comedy, Drama',
      rating: 1,
    },
    {
      name: 'Yodha',
      description: 'Bunny falls in love with Mahalaxmi, whose father Somaraju is a rich businessman. When Somaraju agrees to let them marry, Bunny puts forth the condition that he wants Somaraju\'s entire wealth as dowry.',
      director: 'Sangeeth Sivan',
      releaseDate: '3 September 1992',
      language: 'Malayalam',
      price: 9,
      occupied: [10, 12, 50, 33, 28, 47],
      image: 'yodha.jpeg',
      type: 'Thriller, Drama',
      rating: 8.2,
    },
    {
      name: 'The Presence of Love',
      description: 'An adjunct professor bonds with a single father after traveling to England to visit the farm where her late mother grew up.',
      director: 'Maclain Nelson',
      releaseDate: '19 May 2022',
      language: 'English',
      price: 10,
      occupied: [20, 21, 30, 1, 2, 8],
      image: 'presence.jpg',
      type: 'Thriller, Drama',
      rating: 7.2,
    },
  ]
  export default movies